import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
}), 'OutlinedFlagOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/OutlinedFlagOutlined.js
// module id = 5162
// module chunks = 2